// extracted by mini-css-extract-plugin
export default {"productDescription":"saa-z","featuredDescription":"taa-z","description":"uaa-z","more":"vaa-z","descriptionSku":"waa-z"};